// important: both our local styles and bootstrap will set global styles. Make sure that
// bootstrap is included first so that anything that we specify will override their
// settings.
import "bootstrap-css-only";
import "./setupSentry";
import "./style/style.less";

import * as Sentry from "@sentry/react";
import axios from "axios";
import axiosBetterStacktrace from "axios-better-stacktrace";
import React from "react";
import { Provider } from "react-redux";
import { HistoryRouter as Router } from "redux-first-history/rr6";
import { createRoot } from "react-dom/client";

import { currentUser, initVisitorId } from "./store/actions/auth";
import App from "./components/app";
import { getURL, pushGtm, trackVisitor } from "./components/utils/util";
import { createReduxHistory } from "./store/state/rootReducer";
import { configureStore } from "./store/state/rootStore";

axiosBetterStacktrace(axios);

const store = configureStore();

const history = createReduxHistory(store);

// get/track the visitor id and capture the landing page
const currentVisitor = async () => {
  const visitorId = await trackVisitor(true);
  store.dispatch(initVisitorId(visitorId));
  pushGtm({
    event: "visitor_detected",
    visitor_id: visitorId,
  });
};

axios.defaults.baseURL = getURL();

const main = async () => {
  // ensure the visitor id is available before the rest of the app loads
  // which is why we can't run these two promises in parallel
  // (since otherwise /current_user won't get the visitor ID)
  await currentVisitor();
  await store.dispatch(currentUser());

  window.__myapp_container = document.querySelector(".injection");
  const container = document.getElementById("app");

  const root = createRoot(container);
  root.render(
    <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
      <Provider store={store}>
        <Router history={history}>
          <App />
        </Router>
      </Provider>
    </Sentry.ErrorBoundary>
  );
};

main().catch(Sentry.captureException);
